import React, { useEffect, useState } from 'react';

import { hasRoles, CREATE_PARTICIPANT_ROLES } from '../../../../util/RoleUtil';

import { retrieveParticipants } from '../../../../services/ParticipantService';

import { Table } from '../../../common/table/Table';

import './ParticipantsSearch.css';

export const ParticipantsSearch = ({ context, setContext, navigateToWith, showToaster, setSpinnerText }) => {
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setSpinnerText('Retrieving Participants');
      const [data, error] = await retrieveParticipants(context.username);
      if (data) {
        if (data.responseStatus === 'Success') {
          setSearchResults(data.participants);
        } else {
          showToaster(data);
        }
      } else {
        showToaster({
          responseStatus: 'Error',
          responseMessage: error.message,
        });
      }
      setSpinnerText(null);
    };
    fetchData();
  }, [setSpinnerText, context, setSearchResults, showToaster]);

  useEffect(() => {
    setContext((prevContext) => ({
      ...prevContext,
      canNavigateBack: false,
      navigateContext: null,
    }));
  }, [setContext]);

  const handleRowClick = async (participant) => {
    navigateToWith('participantEdit', '', participant.participantExternalReference);
  };

  const handleAddButtonClick = () => {
    navigateToWith('participantsLinkNew', null, null);
  };

  if (!searchResults) return null;

  return (
    <div className="participants-search">
      <Table
        tableData={searchResults}
        hiddenColumns={['participantExternalReference']}
        searchEnabled={true}
        filterEnabled={true}
        onRowClick={handleRowClick}
        tableTitle={'Participants'}
        buttonText={hasRoles(context, CREATE_PARTICIPANT_ROLES) ? 'Link New' : undefined}
        onButtonClick={handleAddButtonClick}
        buttonOneWidth={'135px'}
        maxRowCount={10}
        horizontalScroll
      />
    </div>
  );
};
